import React from "react";
import { MapPinIcon, PhoneIcon } from "lucide-react";
import { accessNotes, clinic, openingHours } from "../../data/clinic";
export function VisitSection() {
  return <section id="contact" className="scroll-mt-20 border-t border-line bg-white" data-id="element-244" data-mp="d9eu4wttq5oy">
      <div className="mx-auto grid max-w-6xl gap-12 px-5 py-20 md:px-8 md:py-24 lg:grid-cols-12" data-id="element-245" data-mp="d7ar0h3r1apq">
        <div className="lg:col-span-5" data-id="element-246" data-mp="95p74bssrw61">
          <h2 className="text-3xl font-semibold tracking-tight text-ink md:text-4xl" data-id="element-247" data-mp="3hn3kimwx12o4">Venir au cabinet</h2>

          <address className="mt-8 flex gap-3 not-italic" data-id="element-248" data-mp="3cpbi2yyn9y5o">
            <MapPinIcon className="mt-1 h-5 w-5 shrink-0 text-brand" aria-hidden="true" data-id="element-249" data-mp="3cmpax0fo1knz" />
            <span className="text-lg font-medium leading-snug text-ink" data-id="element-250" data-mp="3qi1gk2vd0vjo">
              {clinic.street}
              <br data-id="element-251" data-mp="3lndppxcvvp1x" />
              {clinic.city}
            </span>
          </address>
          <ul className="mt-3 space-y-1 pl-8 text-sm text-muted" data-id="element-252" data-mp="2xxt1p01vi1ls">
            {accessNotes.map(note => <li key={note} data-id="element-253" data-mp="2tvy2c13i5yan">{note}</li>)}
          </ul>

          <a href={clinic.phoneHref} className="mt-6 flex items-center gap-3 text-lg font-medium text-ink hover:text-brand" data-id="element-254" data-mp="2dzrkn2k5ocza">
            <PhoneIcon className="h-5 w-5 text-brand" aria-hidden="true" data-id="element-255" data-mp="2npt0x869or3n" />
            {clinic.phone}
          </a>

          <h3 className="mt-10 text-sm font-semibold text-ink" data-id="element-256" data-mp="2spp8fhe6b0ny">Horaires</h3>
          <dl className="mt-3 divide-y divide-line border-y border-line" data-id="element-257" data-mp="1v1x7qdfwphbm">
            {openingHours.map(row => <div key={row.day} className="flex justify-between gap-4 py-3 text-sm" data-id="element-258" data-mp="1zzyqex9f7emk">
                <dt className="text-muted" data-id="element-259" data-mp="24zbnsbxx443e">{row.day}</dt>
                <dd className="text-right font-medium text-ink" data-id="element-260" data-mp="251xts755ubji">{row.hours}</dd>
              </div>)}
          </dl>
        </div>

        <div className="lg:col-span-7" data-id="element-261" data-mp="3gfjg7kjmxz1c">
          <div className="h-full min-h-[360px] overflow-hidden rounded-3xl border border-line" data-id="element-262" data-mp="3gei3lbmz14hi">
            <iframe title="Plan d'accès au cabinet RD-Kiné" src={clinic.mapEmbed} className="h-full min-h-[360px] w-full" loading="lazy" data-id="element-263" data-mp="3lcjmnwked3sz" />
          </div>
          <a href={clinic.mapLink} target="_blank" rel="noreferrer" className="mt-3 inline-block text-sm font-medium text-brand underline-offset-4 hover:underline" data-id="element-264" data-mp="1geuzzkb6xbf7">
            Ouvrir dans un plan
          </a>
        </div>
      </div>
    </section>;
}